import React from 'react'
import { observer } from 'mobx-react'
import UserShapefile from './UserShapefile'
import { withTranslation } from 'react-i18next'

const UserShapefileList = ({ userShapefileList, shapefiles, onSelect, t }) => {
  const files = shapefiles || userShapefileList.shapefiles || []

  if (files.length === 0) {
    return (
      <div className='shape-file-pane__empty'>
        <span>{t('GLOBAL.NO_SHAPEFILES', { defaultValue: 'No shapefiles uploaded.' })}</span>
      </div>
    )
  }

  return (
    <ul className='shape-file-pane__list'>
      {files.map(shapefile => (
        <UserShapefile
          key={shapefile.id}
          shapefile={shapefile}
          userShapefileList={userShapefileList}
          onSelect={onSelect}
        />
      ))}
    </ul>
  )
}

export default withTranslation()(observer(UserShapefileList))
